/* eslint-disable eqeqeq */
import React, { createRef, Component } from "react";
import "./index.scss";
import { Switch, BrowserRouter, Router, Route } from "react-router-dom";
import { createBrowserHistory } from "history";
import Inicio from "./Components/inicio";
import InicioFormulario from "./Components/inicio/indexFormulario";
import { Elastic, ContenedorMain} from "./Components/ui.js";
import { multimediaEpaycoUrl } from "./utils/multimedia";
import { REACT_APP_INVOICES_MINUTES_ALIVE } from "./config/env";
import Flex from "./Components/UI-Components/Flex";
import InicioOnline from './Components/inicio/indexOnline';
import ListaFacturasOnline from './Components/listafacturas/indexOnline';
import FacturaPagarOnline from './Components/pagaFactura/indexOnline';
import RespuestaOnline from "./Components/respuesta/indexOnline";

/** @jsx jsx */
/* @jsxFrag React.Fragment */
import { jsx, css, keyframes } from "@emotion/core";
import Listafacturas from "./Components/listafacturas";
import FacturaPagar from "./Components/pagaFactura";
import FacturaPagarFormulario from "./Components/pagaFactura/indexFormulario";
import Respuesta from "./Components/respuesta";
import RespuestaFormulario from "./Components/respuesta/indexFormulario";
import RespuestaSuscripcion from "./Components/respuesta/indexSuscripcion";
import {serviceApiResponse, ValidateToken, tokenApi} from "./Components/ServiciosMaestros/request";
import { api } from "./Components/ServiciosMaestros/apis";
import { handleIntegrationError } from "./Components/ServiciosMaestros/handleIntegrationError";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import styled from "@emotion/styled";
import { colors } from "./Components/ui";

import {MainCont,FacturaContainer} from "./Components/UI-Components/layoutComponents/index";

import {
  useTransition,
  animated
} from "react-spring";
import { Modal, Modal2 } from "./Components/ServiciosMaestros/componentGeneral";
import Favicon from "react-favicon";
import Error from "./Components/Error";
import { loadCheckoutPagoScript } from "./utils/loadExternalScript.js";

const Header = createRef();
const footer = createRef();

const Headerepayco = styled.div`
  width: 100%;
  flex: 0 0 auto;
  padding: 1em;
  background-color: ${colors.naranja};
`;

const FooterEpayco = styled.div`
  width: 100%;
  flex: 0 0 auto;
  padding: 1em;
  background-color: #373737;
  border-top: 4px solid ${colors.naranja};
  color: white;
`;

// let altura = css`
//         height:calc(100% - 103px;)
// `;

let logo = css`
  max-height: 30px;
  max-width: 180px;

  img {
    max-width: 100%;
    max-height: 100px;
    width: auto;
    height: auto;
  }

  @media all and (max-width: 766px) {
    margin: auto;

    max-height: 120px;
    max-width: 180px;
    width: auto;
    height: auto;
  }
`;

const Gris = css`
  color: #c0cbd6 !important;
`;

const Cargando = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  position: fixed;
  background: white;
  z-index: 999;
  display: flex;

  small {
    color: #c0cbd6;
    display: block;
    margin-bottom: 1em;
  }

  .line {
    width: 80%;
    height: 6px;
    border-radius: 2px;
    background: #e4e4e4;
    overglow: hidden;
    padding:1px 0;

    .carga {
      height: 4px;
      width: 50px;
      background: #c0cbd6;
    }
  }
`;

const anima = keyframes`
    0%{width:2px; transform:translateX(0)}
    50%{width:20%;}
    100%{width:2px;transform:translateX( calc(80vw - 2px)) }

`;

const Mycargando = ({loading}) => {


    const transitions = useTransition(loading, null, {
        from: {
            position: 'fixed',
            top: "0",
            left: "0",
            zIndex: "999",
            width: "100%",
            height: "100%",
            overflow: "hidden",
            opacity: 1
        },
        enter: {opacity: 1},
        leave: {opacity: 0, height: "0%"},
    });

  return transitions.map(
    ({ item, key, props }) =>
      item && (
        <animated.div key={key} style={props}>
          <Cargando>
            <small>CONSULTANDO SERVICIOS, POR FAVOR ESPERE...</small>
            <div className="line">
              <div
                className="carga"
                css={css`animation: ${anima} 0.5s linear infinite alternate;`}
              > </div>
            </div>
          </Cargando>
          ️
        </animated.div>
      )
  );
};



// let Logocomercio = "";

const NoMatch = ({ location }) => (
  <div>
    <h3>
      No match for <code>{location.pathname}</code>
    </h3>
  </div>
);

const history = createBrowserHistory();

let timeOut1 = null;
let timeOut2 = null;

let home;
let facturas;
let factura;
let respuesta;
let respuestaSuscripcion;

class App extends Component {
  state = {
    plantilla: 1,
    bgColor: "#d1d1d1",
    logo:
      multimediaEpaycoUrl("/dashboard/login/img/favicon-32x32.png"),
    configuracion: [],
    loading: true,
    modal: {
      typo: "info",
      open: false,
      message: "Hola men",
    },
    errorConfiguracion: false,
    errorUrl: {
      codigo: "404",
      titulo: "Error al encontrar la URL",
      mensaje:
        "Tenemos problema para encontrar la pagina que esta buscando, puedes ir a la pagina de ePayco haciendo click en el enlace de abajo",
    },
    tipo: sessionStorage.getItem("tipo")
      ? sessionStorage.getItem("tipo")
      : "",
    titulo: "",
    descripcion: "",
    topes: {
      min: 5000,
      max: 200000,
    },
    plan: false,
    suscripcionProyecto: null,
    rest_horarios: {
      "activo": true,
      "message": ""
    },
    openModal2: false,
  };

  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.initTimeout = this.initTimeout.bind(this);
    this.homePath = this.homePath.bind(this);
    this.validarTimers = this.validarTimers.bind(this);
  }

  componentDidMount() {
    loadCheckoutPagoScript({
      onError: () => {
        handleIntegrationError(new Error("checkout_script_load_failed"), {
          openModal: this.openModal.bind(this),
          flow: "pago",
          service: "epayco-script",
          endpoint: "checkout-script",
          userMessage:
            "No fue posible cargar el módulo de pago. Verifique su conexión e intente nuevamente.",
          setState: (updates) => this.setState(updates),
          stateUpdates: { loading: false },
          modalType: "warning",
        });
      },
    });

    let path = window.location.pathname;
    let paths = path.split("/");
    let proyect = "/";
    if (paths[1] === "recaudo") {
        proyect = `/${paths[1]}/${paths[2]}/`;
        if (
            paths[3] &&
            ((paths[3] !== "facturas" &&
                paths[3] !== "factura" &&
                paths[3] !== "respuesta" &&
                paths[3] !== "respuestaSuscripcion") ||
                paths[4])
        ) {
            this.setState({
                errorConfiguracion: true,
            });
        }
    }
    home = proyect;
    facturas = `${proyect}facturas`;
    factura = `${proyect}factura`;
    respuesta = `${proyect}respuesta`;
    respuestaSuscripcion = `${proyect}respuestaSuscripcion`;
    sessionStorage.setItem(
        "rutas",
        JSON.stringify({
            home,
            facturas,
            factura,
            respuesta,
            respuestaSuscripcion,
        })
    );
    if (!sessionStorage.getItem("ruta")) {
        sessionStorage.setItem("ruta", home);
    }
    sessionStorage.removeItem("reservarConfig");
    this.configuracion();
  }

  componentWillMount() {
    if (!ValidateToken()) {
      tokenApi({}, api.token, "POST").catch((error) => {
        handleIntegrationError(error, {
          openModal: this.openModal.bind(this),
          flow: "consulta",
          service: "recaudo-api",
          endpoint: api.token,
          setState: (updates) => this.setState(updates),
          stateUpdates: { loading: false },
          modalType: "warning",
        });
      });
    }
  }
  
  verificarActualizacion() {
    serviceApiResponse({}, api.actualizacion, "POST")
      .then((response) => {
        if (response.success) {
          if (
            `"${response.data.fecha_actualizacion}"` !==
            sessionStorage.getItem("fechaActualizacion")
          ) {
            this.configuracion(true);
          }
        }
      })
      .catch((error) => {
        return;
      });
  }

  intervalActualizarConfiguracion() {
    let intervalTotalFacturas = setInterval(
      this.verificarActualizacion(),
      5000
    );
    clearInterval(intervalTotalFacturas);
  }

  configuracion(actualizar = true) {
    const urlConfig = api.configuracion;
    let data = {};
    const rutas = JSON.parse(sessionStorage.getItem("rutas"));
    if (sessionStorage.getItem("ruta") !== rutas.home) {
      sessionStorage.removeItem("configuracion");
      sessionStorage.setItem("ruta", rutas.home);
    }
    if (!sessionStorage.getItem("configuracion") || actualizar) { 
    
      serviceApiResponse(data, urlConfig, "POST")
        .then((response) => {
          if (response.success) {
            if(response.data.redirect){
              window.location.href = response.data.redirect;
              return;
            }
            sessionStorage.setItem(
              "configuracion",
              JSON.stringify(response.data)
            );
            sessionStorage.setItem(
              "informacion",
              JSON.stringify(response.data.info)
            );
            sessionStorage.setItem(
              "fechaActualizacion",
              JSON.stringify(response.data.fechaActualizacion)
            );
            sessionStorage.setItem("test", JSON.stringify(response.data.test));
            sessionStorage.setItem("tipo", response.data.tipo);
            sessionStorage.setItem(
              "titulo",
              Object.keys(response.data.plantilla).indexOf("titulo") >= 0
                ? response.data.plantilla.titulo
                : ""
            );
            sessionStorage.setItem(
              "descripcion",
              Object.keys(response.data.plantilla).indexOf("descripcion") >= 0
                ? response.data.plantilla.descripcion
                : ""
            );
            sessionStorage.setItem(
              "plan",
              Object.keys(response.data).indexOf("plan") >= 0
                ? response.data.plan
                : true
            );
            let dataInfo = response.data;
            let plantilla = dataInfo.plantilla;
            this.setState(
              {
                loading: false,
                bgColor: plantilla.color,
                plantilla: plantilla.codigo_plantilla.substr(-1, 1),
                logo: plantilla.logo || response.data.info.logoComercio,
                titulo:
                  Object.keys(plantilla).indexOf("titulo") >= 0
                    ? plantilla.titulo
                    : "",
                descripcion:
                  Object.keys(plantilla).indexOf("descripcion") >= 0
                    ? plantilla.descripcion
                    : "",
                configuracion: dataInfo.busqueda,
                informacion: response.data.info,
                tipo: response.data.tipo,
                topes: response.data.topes,
                plan: response.data.plan ? response.data.plan : true,
                suscripcionProyecto:
                  response.data.info.suscripcionProyecto || null,
                rest_horarios: response.data.rest_horarios
              },
              () => {
                this.urlString();
              }
            );
          } else {
            this.setState(
              {
                loading: false,
                errorConfiguracion: true,
              }
            );
          }
        })
        .catch((error) => {
          handleIntegrationError(error, {
            openModal: this.openModal.bind(this),
            flow: "consulta",
            service: "recaudo-api",
            endpoint: api.configuracion,
            setState: (updates) => this.setState(updates),
            stateUpdates: { loading: false, errorConfiguracion: true },
            modalType: "warning",
          });
        });
    } else {
      let tipo = sessionStorage.getItem("tipo");
      let dataInfo = JSON.parse(sessionStorage.getItem("configuracion"));
      let titulo = sessionStorage.getItem("titulo");
      let descripcion = sessionStorage.getItem("descripcion");
      let plan = sessionStorage.getItem("plan");
      let plantilla = dataInfo.plantilla;
      this.setState(
        {
          loading: false,
          bgColor: plantilla.color,
          plantilla: plantilla.codigo_plantilla.substr(-1, 1),
          logo: plantilla.logo || dataInfo.info.logoComercio,
          titulo,
          descripcion,
          configuracion: dataInfo.busqueda,
          informacion: JSON.parse(sessionStorage.getItem("informacion")),
          tipo,
          topes: dataInfo.topes,
          plan: plan,
        },
        () => {
          this.urlString();
        }
      );
    }
  }

  toast = (type, message) => {
        return (
            toast(message, {
                hideProgressBar: true,
                type: type
            })
        )
    };

  openModal(menssage, type) {
    this.setState({
      modal: {
        open: true,
        message: menssage,
        typo: type,
      },
    });
  }

  closeModal() {
    this.setState({
      modal: {
        open: false,
        modalMessage: "",
        type: "",
      },
    });
  }

  urlString() {
    sessionStorage.removeItem("autoCheckout");
    let urlstring = window.location.search;
    let option1 = "";
    let value1 = "";
    let tituloCampo = "";
    let configuration = null;
    let openChechout = false;
    let arrConsult = [];
    if (urlstring) {
      const quitarSignoInt = urlstring.split("?");
      if (urlstring.length > 1) {
        const variables = quitarSignoInt[1].split("&");
        if (variables.length > 0) {
          variables.map((vari) => {
            let extraerData = vari.split("=");
            if (extraerData.length > 0) {
              configuration = JSON.parse(
                sessionStorage.getItem("configuracion")
                );
              if (extraerData[0] === "option1") {
                if (parseInt(extraerData[1]) !== "NaN") {
                  if (configuration.busqueda.length >= parseInt(extraerData[1]))
                    option1 = configuration.busqueda[parseInt(extraerData[1]) - 1]["tipo_campo"];
                    tituloCampo = configuration.busqueda[parseInt(extraerData[1]) - 1]["titulo_campo"];
                }
              }else{
                if(extraerData[0] != "checkout" && extraerData[0] != "ref_payco"){
                  arrConsult.push({
                    parametro:extraerData[0],
                    value: extraerData[1]
                  })
                }
              }

              if (extraerData[0] === "value1") {
                value1 = decodeURI(extraerData[1]);
              }

              if (extraerData[0] === "checkout") {
                if (extraerData[1] === "true") {
                  openChechout = true;
                }
              }
            }
          });
        }
      }
    }
    if (option1 !== "" && value1 !== "" && configuration.tipo == 'archivo') {
      this.buscarFactura(tituloCampo, openChechout, option1, value1);

    }else if(configuration && configuration.tipo == 'online' && arrConsult.length > 0){
      this.child.current.consultarFactura(arrConsult,openChechout);
    }
  }

  buscarFactura(option, openCheckout, option1, value1) {
    if (this.state.valueSelect !== "" && this.state.value1 !== "") {
      this.setState({
        loading: true,
      });

      sessionStorage.removeItem("total");
      sessionStorage.removeItem("facturas");
      sessionStorage.removeItem("paginacion");
      sessionStorage.removeItem("facturaPagar");

      let data = {
        referencia: value1,
        band: "r",
        option: option1,
      };
      serviceApiResponse(data, api.facturas, "POST")
        .then((response) => {
          const getTipoMoneda = (moneda) => {
              let tipoMoneda = moneda;
              if(tipoMoneda){
                  tipoMoneda = tipoMoneda ? tipoMoneda.value : 'COP'
              }else{
                  tipoMoneda = 'COP'
              }
              return tipoMoneda ? tipoMoneda : 'COP';
          }
          if (response.success) {
            this.setState(
              {
                loading: false,
                data: response.data,
              },
              () => {
                if (response.data.facturas.length > 0) {
                  if (response.data.facturas.length === 1)
                    sessionStorage.setItem("facturaPagar", 0);
                  sessionStorage.setItem(
                    "facturas",
                    JSON.stringify(response.data.facturas)
                  );
                  sessionStorage.setItem(
                    "configCampos",
                    JSON.stringify(response.data.configCampos)
                  );
                  sessionStorage.setItem(
                    "total",
                    JSON.stringify(response.data.total)
                  );
                  sessionStorage.setItem(
                    "param",
                    JSON.stringify({
                      referencia: value1,
                      option: option,
                      optionDb: option1,
                    })
                  );
                  if (sessionStorage.getItem("check")) {
                    sessionStorage.removeItem("check");
                    sessionStorage.removeItem("checksOtroValor");
                    sessionStorage.removeItem("checksValor1");
                    sessionStorage.removeItem("checksValor2");
                    sessionStorage.removeItem("checksValor3");
                    sessionStorage.removeItem("valuesOtroValor");
                  }
                  let opcionesRecaudo = response.data.opcionesRecaudo;
                  if (opcionesRecaudo) {
                    sessionStorage.setItem(
                      "opcionesRecaudo",
                      JSON.stringify({
                        ...response.data.opcionesRecaudo, moneda: {
                        value: getTipoMoneda(response.data.opcionesRecaudo.moneda)
                    }})
                    );
                  }

                  sessionStorage.setItem(
                    "paginacion",
                    JSON.stringify(response.data.paginacionFacturas)
                  );
                  let ruta = JSON.parse(sessionStorage.getItem("rutas"));
                  if (response.data.facturas.length === 1) {
                    sessionStorage.setItem("autoCheckout", openCheckout);
                    sessionStorage.setItem("noRederict", 'true');
                    history.push({pathname: ruta.factura, isSuscrito: false })
                    window.location.reload();
                  } else {
                    sessionStorage.setItem("noRederict", 'true');
                    history.push({pathname: ruta.facturas, isSuscrito: false })
                    window.location.reload();
                  }
                } else {
                  if (Object.keys(response.data).indexOf("producto") >= 0) {
                    if (!response.data.producto)
                      this.openModal(
                        `El servicio se encuentra temporalmente suspendido, lo invitamos a contactar con la ${
                          this.state.informacion.nombreEmpresa
                        } para obtener mayor información al (${
                          this.state.informacion.tipoTelefonoValue === "fijo"
                            ? this.state.informacion.valueIndicativo
                            : this.state.informacion.indicativoPais
                        }) ${
                          this.state.informacion.tel_empresa
                        } o correo electrónico ${
                          this.state.informacion.correo_empresa
                        }.`,
                        "info"
                      );
                    else
                      this.openModal(
                        "No cuenta con facturas pendientes por pagar",
                        "info"
                      );
                  } else {
                    this.openModal(
                      "No cuenta con facturas pendientes por pagar",
                      "info"
                    );
                  }
                }
              }
            );
          } else {
            this.setState({
              loading: false,
            });
            if (Object.keys(response.data).indexOf("producto") >= 0) {
              if (!response.data.producto)
                this.openModal(
                  `El servicio se encuentra temporalmente suspendido, lo invitamos a contactar con la ${
                    this.state.informacion.nombreEmpresa
                  } para obtener mayor información al (${
                    this.state.informacion.tipoTelefonoValue === "fijo"
                      ? this.state.informacion.valueIndicativo
                      : this.state.informacion.indicativoPais
                  }) ${
                    this.state.informacion.tel_empresa
                  } o correo electrónico ${
                    this.state.informacion.correo_empresa
                  }.`,
                  "info"
                );
              else
                this.openModal(
                  "Ocurrió un error al consultar la factura, por favor intente más tarde",
                  "warning"
                );
            } else {
              this.openModal(
                "Ocurrió un error al consultar la factura, por favor intente más tarde",
                "warning"
              );
            }
          }
        })
        .catch((error) => {
          handleIntegrationError(error, {
            openModal: this.openModal.bind(this),
            flow: "consulta",
            service: "recaudo-api",
            endpoint: api.facturas,
            setState: (updates) => this.setState(updates),
            stateUpdates: { loading: false },
            modalType: "warning",
          });
        });
    }
    else {
      if (this.state.valueSelect === "" && this.state.value1 === "") {
        this.setState({
          errorValue1: `¡Campo requerido!`,
          errorSelect: "¡Debe seleccionar un tipo de dato!",
        });
      }
      else if (this.state.valueSelect === "") {
        this.setState({
          errorSelect: "¡El campo es obligatorio!",
        });
      } else {
        this.setState({
          errorValue1: `¡El campo ${this.state.nameSelect} es obligatorio!`,
        });
      }
    }
  }
  homePath(){
    const ruta = JSON.parse(sessionStorage.getItem("rutas"));
    sessionStorage.removeItem("reservarConfig");
    history.push(ruta.home);
    window.location.reload();
    this.setState({openModal2: false})
  }
  validarRutas(rutas, path){
    return !(path == rutas.respuesta || path == rutas.home || path == rutas.respuestaSuscripcion);
  }
  validarTimers(){
    return timeOut1 || timeOut2;
  }
  initTimeout(){
    const config = JSON.parse(sessionStorage.getItem("reservarConfig")) || {
      type: "MINUTE",
      value: REACT_APP_INVOICES_MINUTES_ALIVE || 60
    };
    const rutas = JSON.parse(sessionStorage.getItem("rutas")) || null;
    if(config && (rutas ? this.validarRutas(rutas, window.location.pathname) : false) && !this.validarTimers()){
      let time = 0;
      switch (config.type) {
        case 'HOUR':
          time = config.value*3600;
          break;
        case 'MINUTE':
        default:
          time = config.value*60;
          break;
      }
      if(time > 0){
        timeOut1 = setTimeout(() => {
          this.setState({openModal2: true});
          timeOut2 = setTimeout(() => {
            this.homePath()
          }, 30*1000);
        }, time*1000);
      }
    }else if(config && rutas && !this.validarRutas(rutas, window.location.pathname) && this.validarTimers()){
      clearTimeout(timeOut1);
      clearTimeout(timeOut2);
    }
  }
componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.location !== prevProps.location) {
      this.initTimeout();
    }
}
    render() {
        return (

            <ContenedorMain
                id={"main-scroll"}
                className={"Apps"}
                bgColor={!this.state.errorConfiguracion? this.state.bgColor : "white"}
            >
                <Favicon url={this.state.logo}/>
                <Modal
                    open={this.state.modal.open}
                    close={() => this.closeModal()}
                    message={this.state.modal.message}
                    tipo={this.state.modal.typo}
                />
                <Modal2
                  open={this.state.openModal2}
                  close={() => null}
                  Logo={require('./assets/TiempoLimite.svg')}
                  IconoClass={"icono iconoTiempo"}
                  ImgClass={"imgTiempo"}
                  ModalClass={"mimodal-modal2 mimodal-modalTiempo"}
                  customMessage={<div className="txtTiempo">
                    Tiempo de espera superado, favor volver a generar la consulta.
                    <br/>
                    <button
                      className={"btn-timeout-back"}
                      onClick={() => this.homePath()}
                    >Volver</button>
                  </div>}
                  tipo={""}
                  />
                <Mycargando loading={this.state.loading}/>

                <MainCont
                    plantilla={!this.state.errorConfiguracion ? this.state.plantilla : "none"}
                >
                    {!this.state.errorConfiguracion ?
                        <Elastic className={"container py-3 px-md-0 pb-md-0"} ref={Header}>
                            <div className="logo text-center text-md-left" css={logo}>
                                <img src={this.state.logo} alt="" />
                            </div>
                        </Elastic> :
                        <Headerepayco>
                            <div className="container text-center text-md-left">
                                <img
                                    src={multimediaEpaycoUrl("/dashboard/recaudo/proyecto/imagenes/logoepayco.png")}
                                    alt=""
                                />
                            </div>
                        </Headerepayco>
                    }
                    <Flex
                        direction={"column"}
                        elastic={["1 0 auto","1 0 auto","1 0 auto","1 0 auto"]}
                        className={"container px-2 height-auto"}
                        jc={["flex-start","flex-start","center",]}
                    >
                        <FacturaContainer>
                            <Router history={history}>
                            {!this.state.errorConfiguracion ? (
                                <BrowserRouter>
                                    <Switch>
                                    {this.state.tipo === "archivo" ?
                                        <>
                                            <Route
                                                path="/recaudo/:id"
                                                exact={true}
                                                render={props => (
                                                    <Inicio
                                                        configuracion={this.state.configuracion}
                                                        openModal={this.openModal.bind(this)}
                                                        closeModal={this.closeModal.bind(this)}
                                                        suscripcionProyecto={this.state.suscripcionProyecto}
                                                        rest_horarios={this.state.rest_horarios}
                                                        {...props}
                                                    />
                                                )}
                                            />
                                            <Route path="/recaudo/:id/facturas" exact={true}
                                                   render={props =>
                                                       {
                                                        this.initTimeout();
                                                        return <Listafacturas
                                                          openModal={this.openModal.bind(this)}
                                                          closeModal={this.closeModal.bind(this)}
                                                          {...props}
                                                          />
                                                       }
                                                   }/>
                                            <Route path="/recaudo/:id/factura" exact={true} render={props => 
                                            {
                                              this.initTimeout();
                                              return <FacturaPagar
                                                info={this.state.informacion}
                                                openModal={this.openModal.bind(this)}
                                                closeModal={this.closeModal.bind(this)}
                                                {...props}
                                                />
                                             }}/>
                                            <Route path="/recaudo/:id/respuesta" exact={true} render={() => <Respuesta/>}/>
                                            <Route
                                                path="/recaudo/:id/respuestaSuscripcion"
                                                exact={true}
                                                render={(props) => (
                                                    <RespuestaSuscripcion
                                                        responseInfo={
                                                            sessionStorage.getItem("responseSubscription") ||
                                                            null
                                                        }
                                                    />
                                                )}
                                            />
                                        </>

                                    :(this.state.tipo === "web" ?
                                            <>
                                                <Route path="/recaudo/:id" exact={true} render=
                                                    {props =>
                                                        <InicioFormulario
                                                            configuracion={this.state.configuracion}
                                                            titulo={this.state.titulo}
                                                            descripcion={this.state.descripcion}
                                                            topes={this.state.topes}
                                                            openModal={this.openModal.bind(this)}
                                                            closeModal={this.closeModal.bind(this)}
                                                            rest_horarios={this.state.rest_horarios}
                                                            {...props}
                                                        />
                                                    }
                                                />
                                                <Route path="/recaudo/:id/factura" exact={true} render={props =>
                                                    <FacturaPagarFormulario
                                                        openModal={this.openModal.bind(this)}
                                                        closeModal={this.closeModal.bind(this)}
                                                        {...props}
                                                    />
                                                }/>
                                                <Route path="/recaudo/:id/respuesta" exact={true} render={() =>
                                                    <RespuestaFormulario
                                                        openModal={this.openModal.bind(this)}
                                                        closeModal={this.closeModal.bind(this)}
                                                        {...this.props}
                                                    />}/>
                                                <Route
                                                    path="/recaudo/:id/respuestaSuscripcion"
                                                    exact={true}
                                                    render={() => (
                                                        <RespuestaSuscripcion
                                                            openModal={this.openModal.bind(this)}
                                                            closeModal={this.closeModal.bind(this)}
                                                            {...this.props}
                                                        />
                                                    )}
                                                />
                                            </> :
                                            (this.state.tipo === "online" && <>
                                                <Route path="/recaudo/:id" exact={true} render=
                                                    {props =>
                                                        <InicioOnline
                                                            configuracion={this.state.configuracion}
                                                            titulo={this.state.titulo}
                                                            descripcion={this.state.descripcion}
                                                            topes={this.state.topes}
                                                            openModal={this.openModal.bind(this)}
                                                            closeModal={this.closeModal.bind(this)}
                                                            ref={this.child}
                                                            rest_horarios={this.state.rest_horarios}
                                                            {...props}
                                                        />
                                                    }
                                                />
                                                <Route path="/recaudo/:id/facturas" exact={true} render=
                                                    {props =>
                                                        {
                                                          this.initTimeout();
                                                          return <ListaFacturasOnline
                                                            configuracion={this.state.configuracion}
                                                            titulo={this.state.titulo}
                                                            descripcion={this.state.descripcion}
                                                            topes={this.state.topes}
                                                            openModal={this.openModal.bind(this)}
                                                            closeModal={this.closeModal.bind(this)}
                                                            {...props}
                                                        />
                                                      }
                                                    }
                                                />
                                                <Route path="/recaudo/:id/factura" exact={true} render={props =>
                                                    {
                                                      this.initTimeout();
                                                      return <FacturaPagarOnline
                                                        info={this.state.informacion}
                                                        openModal={this.openModal.bind(this)}
                                                        closeModal={this.closeModal.bind(this)}
                                                        {...props}
                                                      />
                                                  }
                                                }/>
                                                <Route path="/recaudo/:id/respuesta" exact={true} render={() => <RespuestaOnline/>}/>
                                            </>))}
                                    </Switch>
                                </BrowserRouter> ): (
                                <Error
                                    codigo={this.state.errorUrl.codigo}
                                    titulo={this.state.errorUrl.titulo}
                                    mensaje={this.state.errorUrl.mensaje}
                                />
                            )}
                        </Router>
                        </FacturaContainer>
                        {!this.state.errorConfiguracion &&
                        <Elastic className={"wc d-none d-md-block"}>
                            <div className="col-12 col-md-6 col-lg-4 text-center pt-3 cb mx-auto"
                                 css={this.state.plantilla !== "3" ? Gris : ""}>
                                <p className={"mb-0"}>Los pagos son procesados de <br/> forma segura por ePayco</p>
                            </div>
                        </Elastic>}
                    </Flex>
                    {!this.state.errorConfiguracion ?
                        <Elastic
                            className={"py-3 container text-center text-md-right px-md-0 mt-3 mt-md-0 pt-md-0 mt-md-0"}
                            ref={footer}>

                                <img
                                    src={multimediaEpaycoUrl("/dashboard/recaudo/proyecto/imagenes/poweredbyepayco.svg")}
                                    alt="ePayco"
                                    height={"22px"}
                                    width={"auto"}
                                    className={"ml-1"}
                                />
                        </Elastic> :
                        <FooterEpayco>
                            <Flex className={"container py-3 px-md-0"}>
                                <div className="col-12 col-md-6 text-center text-md-left pb-3 pb-md-0">
                                    <small>Copyright 2011 - 2019 ePayco.co</small>
                                </div>
                                <Flex className="col-12 col-md-6">
                                    <a href="" className={"d-block pl-3 cb"}>Términos y condiciones</a>
                                    <a href="" className={"d-block pl-3 cb"}>Políticas de privacidad</a>
                                </Flex>
                            </Flex>
                        </FooterEpayco>
                    }
                </MainCont>

            </ContenedorMain>

        );
    }
}

export default App;
